import React from 'react';
import { FormContext } from './index';

let useDisabled = () => React.useContext(FormContext)?.disabled;

export default useDisabled;
